import { Shield, Wrench, Cpu, Globe } from "lucide-react";

export default function TrustBarSection() {
  return (
    <section className="py-12 px-4 sm:px-6 lg:px-8 bg-white border-b border-slate-100" data-testid="trust-bar-section">
      <div className="max-w-7xl mx-auto">
        <p className="text-center text-sm text-slate-500 mb-8 tracking-wide">
          Purpose-built for ISO 22301 compliance across regulated industries.
        </p>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          <div className="text-center" data-testid="trust-metric-industries">
            <div className="flex items-center justify-center mb-2">
              <Globe className="w-5 h-5 text-sky-700 mr-2" />
              <span className="text-3xl sm:text-4xl font-black text-slate-950 tracking-tight">Every</span>
            </div>
            <p className="text-xs font-bold uppercase tracking-[0.15em] text-slate-500">Industry Sector Covered</p>
          </div>
          <div className="text-center" data-testid="trust-metric-ai">
            <div className="flex items-center justify-center mb-2">
              <Cpu className="w-5 h-5 text-sky-700 mr-2" />
              <span className="text-3xl sm:text-4xl font-black text-slate-950 tracking-tight">AI-Native</span>
            </div>
            <p className="text-xs font-bold uppercase tracking-[0.15em] text-slate-500">Across All 14+ Modules</p>
          </div>
          <div className="text-center" data-testid="trust-metric-workarounds">
            <div className="flex items-center justify-center mb-2">
              <Wrench className="w-5 h-5 text-sky-700 mr-2" />
              <span className="text-3xl sm:text-4xl font-black text-slate-950 tracking-tight">Pre-Built</span>
            </div>
            <p className="text-xs font-bold uppercase tracking-[0.15em] text-slate-500">Offline Fallback Playbooks</p>
          </div>
          <div className="text-center" data-testid="trust-metric-compliance">
            <div className="flex items-center justify-center mb-2">
              <Shield className="w-5 h-5 text-sky-700 mr-2" />
              <span className="text-3xl sm:text-4xl font-black text-slate-950 tracking-tight">Full PDCA</span>
            </div>
            <p className="text-xs font-bold uppercase tracking-[0.15em] text-slate-500">Plan-Do-Check-Act Cycle</p>
          </div>
        </div>
      </div>
    </section>
  );
}
